module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.includeMeta) ? _c('div', {
    staticClass: "meta"
  }, [_c('h1', [_vm._v(_vm._s(_vm.meta.title._content))])]) : _vm._e(), _vm._v(" "), (_vm.hasSizesData) ? _c('img', {
    staticClass: "img-responsive img-loadable",
    class: {
      'loaded': _vm.imageLoaded
    },
    attrs: {
      "src": _vm.getSource(),
      "alt": _vm.meta.title._content
    },
    on: {
      "load": _vm.handleImageLoad
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-35434bf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Photo.vue
// module id = 122
// module chunks = 2